import {getCurrencyRateQuery} from './get-currency-rate'
import {getVenueQuery} from './get-venue'
import {getVenueDisplaySettingsQuery} from './get-venue-display-settings'

export const VenueQueries = {getVenueQuery, getVenueDisplaySettingsQuery, getCurrencyRateQuery}
